













































































































































import { Vue, Prop, Component } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import api from "@/getinfo-api";
import { Payment as IPayment } from "@/api-v2/agent/models/payment";
import { PaymentEdit as IPaymentEdit } from "@/api/models/payment-edit";

@Component({
  components: {
    CustomButton,
    CustomDatepicker,
    CustomTableCol,
    CustomTableItem
  }
})
export default class AgentPaymentTableItem extends Vue {
  @Prop() payment!: IPayment;
  @Prop({ default: false }) isSelected?: boolean;
  isLoading: boolean = false;
  isShowEditForm: boolean = false;
  paymentDate?: Date = this.payment?.agentPaymentAt ?? undefined;

  get _checked() {
    return this.isSelected;
  }

  set _checked(value) {
    value ? this.selectPayment() : this.unselectPayment();
  }

  selectPayment() {
    this.$emit("select:add", this.payment);
  }

  unselectPayment() {
    this.$emit("select:remove", this.payment);
  }

  async editAgentPaymentDate() {
    try {
      this.isLoading = true;
      const agentPayment: IPaymentEdit = {
        agentPaymentAt: this.paymentDate ?? undefined
      };
      const { data } = await api.BillApi.editPayment(
        this.payment.billId,
        this.payment.id,
        agentPayment
      );
      const responseAgentPaymentAt = {
        paymentId: this.payment?.id,
        agentPaymentAt: data.agentPaymentAt
      };

      this.$emit("changeDateAgentPaymentAt", responseAgentPaymentAt);
      this.isShowEditForm = false;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }
}
